import { Routes, Route, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Loading from "../Loading/Loading";
import axios from "axios";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import AbsenceLineInformation from "./AbsenceLineInformation";

function formatDate(date) {
  let dateObj = new Date(date);
  let month = parseInt(dateObj.getMonth()) + 1;
  return dateObj.getDate() + "." + month + "." + dateObj.getFullYear();
}

function formatMonth(monthNo) {
  const monthNames = ["Jan", "Feb", "March", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  return monthNames[monthNo - 1];
}

export default function Absence() {
  const [loading, setLoading] = useState(true);

  const [absenceData, setAbsenceData] = useState([]);
  const [totalsData, setTotalsData] = useState(null);

  const [viewedEntry, setViewedEntry] = useState(null);
  const [absenceLineInformationOpen, setAbsenceLineInformationOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      let response = await axios.get(`/api/absence`);
      let totalsData = {
        sicknessHours: response.data.sicknessHours,
        familySicknessHours: response.data.familySicknessHours,
        unpaidLeaveHours: response.data.unpaidLeaveHours,
        sicknessHoursYear: response.data.sicknessHoursYear,
        familySicknessHoursYear: response.data.familySicknessHoursYear,
        unpaidLeaveHoursYear: response.data.unpaidLeaveHoursYear,
        sicknessHoursTotal: response.data.sicknessHoursTotal,
        familySicknessHoursTotal: response.data.familySicknessHoursTotal,
        unpaidLeaveHoursTotal: response.data.unpaidLeaveHoursTotal
      }
      setAbsenceData(processRows(response.data.data));
      setTotalsData(totalsData);
      console.log(response.data)
      setLoading(false);
    }

    fetchData()
      .catch(console.error);
  }, []);

  const processRows = rows => {
    let sorted = rows.sort(function (a, b) { return new Date(b.date) - new Date(a.date); });
    let formattedRows = [];
    let tmp = [];
    let currentMonth = sorted[0].monthNo;
    sorted.forEach(row => {
      if (row.monthNo === currentMonth) {
        tmp.push(row);
      } else {
        formattedRows.push(tmp);
        currentMonth = row.monthNo;
        tmp = [];
        tmp.push(row)
      }
    })

    if (tmp.length > 0) {
      formattedRows.push(tmp)
    }
    return formattedRows;
  }

  const closeModal = () => {
    setViewedEntry(null);
    setAbsenceLineInformationOpen(false);
  };

  if (loading) {
    return <Loading />
  } else {
    return (
      <div>
      <AbsenceLineInformation
          open={absenceLineInformationOpen}
          entry={viewedEntry}
          handleClose={closeModal}
        />
        <Typography variant="h6" component="div" style={{ padding: 16 }}>
          Absence Overview
        </Typography>
        <TableContainer component={Paper}>

          <Table sx={{ minWidth: "100%", padding: 16 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize: 12, fontWeight: "bold", minWidth: 62 }}>Period</TableCell>
                <TableCell style={{ fontSize: 12, fontWeight: "bold", minWidth: 10 }}>Sickness</TableCell>
                <TableCell style={{ fontSize: 12, fontWeight: "bold", minWidth: 20 }}>Family Sickness</TableCell>
                <TableCell style={{ fontSize: 12, fontWeight: "bold", minWidth: 20 }}>Unpaid Leave</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row" style={{ fontSize: 12, fontWeight: "bold" }}>{formatMonth(new Date().getMonth())}</TableCell>
                <TableCell component="th" scope="row">{totalsData.sicknessHours}</TableCell>
                <TableCell component="th" scope="row">{totalsData.familySicknessHours}</TableCell>
                <TableCell>{totalsData.unpaidLeaveHours}</TableCell>
              </TableRow>
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row" style={{ fontSize: 12, fontWeight: "bold" }}>12 months</TableCell>
                <TableCell component="th" scope="row">{totalsData.sicknessHoursYear}</TableCell>
                <TableCell component="th" scope="row">{totalsData.familySicknessHoursYear}</TableCell>
                <TableCell>{totalsData.unpaidLeaveHoursYear}</TableCell>
              </TableRow>
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row" style={{ fontSize: 12, fontWeight: "bold" }}>All</TableCell>
                <TableCell component="th" scope="row">{totalsData.sicknessHoursTotal}</TableCell>
                <TableCell component="th" scope="row">{totalsData.familySicknessHoursTotal}</TableCell>
                <TableCell>{totalsData.unpaidLeaveHoursTotal}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>


        <Typography variant="h6" component="div" style={{ padding: 16 }}>
          Recently registered absence
        </Typography>
        <TableContainer component={Paper}>

          <Table sx={{ minWidth: "100%" }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize: 13, fontWeight: "bold", width: 1 }}>Week</TableCell>
                <TableCell style={{ fontSize: 13, fontWeight: "bold", width: 1 }} align="left">Month</TableCell>
                <TableCell style={{ fontSize: 13, fontWeight: "bold" }}>Date</TableCell>
                <TableCell style={{ fontSize: 13, fontWeight: "bold" }} align="right">Hours</TableCell>
                <TableCell style={{ fontSize: 13, fontWeight: "bold", width: 1 }} align="right">Status</TableCell>
              </TableRow>
            </TableHead>
          </Table>
          {absenceData.length > 0 && (absenceData.map((formattedRows, i) => (
            <Table sx={{ width: "100%", marginBottom: 3 }} key={i}>
              <TableBody>
                {formattedRows.length > 0 && (formattedRows.map((row, index) => (
                  <TableRow
                    key={index}
                    onClick={() => { setViewedEntry(row); setAbsenceLineInformationOpen(true); }}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: "pointer" }}
                    style={row.status === "Submitted" || row.status === "Approved" || row.status === "Pending" ? { backgroundColor: "#c3e6cb" } : { backgroundColor: "#f5c6cb" }}>
                    <TableCell component="th" scope="row" style={{ width: 30 }}>{row.weekNo}</TableCell>
                    <TableCell component="th" scope="row" style={{ width: 30 }} align="left">{formatMonth(row.monthNo)}</TableCell>
                    <TableCell component="th" scope="row" style={{ minWidth: 1 }}>{formatDate(row.date)}</TableCell>
                    <TableCell align="right">{row.quantity}</TableCell>
                    <TableCell align="right" style={{ width: 60 }}>{row.status}</TableCell>
                  </TableRow>
                )))}
              </TableBody>
            </Table>
          )))}
        </TableContainer>
      </div>
    );
  }
}